/*This file was generated by Fumadocs. Do not edit this file directly. Any changes should be made by running the generation command again.*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Get status of Remote Caching for this principal",
  "description": "Check the status of Remote Caching for this principal. Returns a JSON-encoded status indicating if Remote Caching is enabled, disabled, or disabled due to usage limits.",
  "full": true,
  "_openapi": {
    "method": "GET",
    "route": "/v8/artifacts/status",
    "toc": [],
    "structuredData": {
      "headings": [],
      "contents": [{
        "content": "Check the status of Remote Caching for this principal. Returns a JSON-encoded status indicating if Remote Caching is enabled, disabled, or disabled due to usage limits."
      }]
    }
  }
};
export let structuredData = {
  "contents": [{
    "content": "Check the status of Remote Caching for this principal. Returns a JSON-encoded status indicating if Remote Caching is enabled, disabled, or disabled due to usage limits."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const {APIPage} = props.components || ({});
  if (!APIPage) _missingMdxReference("APIPage", true);
  return _jsxs(_Fragment, {
    children: ["\n", _jsx(APIPage, {
      document: "./.openapi.json",
      operations: [{
        "path": "/v8/artifacts/status",
        "method": "get"
      }],
      webhooks: [],
      hasHead: false
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
